import { render, staticRenderFns } from "./FormTypesOfDangers.vue?vue&type=template&id=14ba20fb"
import script from "./FormTypesOfDangers.vue?vue&type=script&lang=js"
export * from "./FormTypesOfDangers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports